import React from 'react';
import { StoryObject } from '@benzinga/basic-news-manager';
import { Button } from '@benzinga/core-ui';
import { BenzingaBriefs } from '@benzinga/news';
import styles from './BenzingaBriefsBlock.module.scss';

interface BenzingaBriefsProps {
  attrs?: {
    data?: {
      show_see_all_button?: boolean;
      initialBriefs?: StoryObject[];
    };
  };
}

export const BenzingaBriefsBlock: React.FC<BenzingaBriefsProps> = ({ attrs }) => {
  const showSeeAllButton = attrs?.data?.show_see_all_button;
  return (
    <div className={styles.wrapper}>
      <BenzingaBriefs initialBriefs={attrs?.data?.initialBriefs || []} />
      {showSeeAllButton && (
        <a
          className="benzinga-briefs-footer"
          data-action="Benzinga Briefs See More Click"
          href="https://www.benzinga.com/benzinga-briefs"
        >
          <Button className={styles.seeAllButton} variant="primary">
            <span>See All</span>
          </Button>
        </a>
      )}
    </div>
  );
};
